// extracted by mini-css-extract-plugin
export var productImage = "_m2-1";
export var viewLink = "_m2-2";
export var wishlistItem = "_m2-0";